import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TransactionForm from '../components/TransactionForm';
import ResultDisplay from '../components/ResultDisplay';
import useAccountingApi from '../../../../hooks/useAccountingApi';

const SalesPurchase = () => {
  const [formData, setFormData] = useState({
    description: '',
    amount: '',
    transactionType: '',
    paymentMethod: '',
    customerInfo: '',
    terms: ''
  });
  const [showExamples, setShowExamples] = useState(true);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const { loading, error, getSuggestion, submitFeedback } = useAccountingApi();
  const [result, setResult] = useState(null);

  const examples = [
    '상품 매출 - 현금 결제',
    '원재료 매입 - 외상',
    '외상매출금 회수 - 계좌이체'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await getSuggestion({
        ...formData,
        category: 'SALES',
        transactionType: formData.transactionType
      });
      setResult(data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const handleFeedback = async (isHelpful) => {
    try {
      await submitFeedback({
        category: 'SALES',
        isHelpful,
        suggestion: result,
        userInput: formData
      });
      setFeedbackSubmitted(true);
    } catch (err) {
      console.error('Feedback Error:', err);
    }
  };

  const handleReset = () => {
    setFormData({
      description: '',
      amount: '',
      transactionType: '',
      paymentMethod: '',
      customerInfo: '',
      terms: ''
    });
    setResult(null);
    setFeedbackSubmitted(false);
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-8">
        <div className="flex items-center mb-4">
          <Link to="/services" className="text-blue-600 hover:text-blue-700">
            ← 서비스 선택으로 돌아가기
          </Link>
        </div>
        <h1 className="text-2xl font-bold text-gray-900">매출/매입 분개</h1>
        <p className="mt-2 text-gray-600">
          상품 매출, 원재료 매입, 외상매출금/매입금 관련 분개를 추천해드립니다.
        </p>
      </div>

      <div className="space-y-8">
        {!result && (
          <div className="bg-white rounded-lg shadow-lg p-6">
            <TransactionForm
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleSubmit}
              loading={loading}
              showExamples={showExamples}
              setShowExamples={setShowExamples}
              examples={examples}
              additionalFields={[
                {
                  name: 'transactionType',
                  label: '거래 유형',
                  type: 'select',
                  options: [
                    { value: 'sales', label: '매출' },
                    { value: 'purchase', label: '매입' },
                    { value: 'receivable', label: '외상매출금' },
                    { value: 'payable', label: '외상매입금' }
                  ]
                },
                {
                  name: 'paymentMethod',
                  label: '결제 방법',
                  type: 'select',
                  options: [
                    { value: 'cash', label: '현금' },
                    { value: 'card', label: '카드' },
                    { value: 'transfer', label: '계좌이체' },
                    { value: 'credit', label: '외상' }
                  ]
                },
                {
                  name: 'customerInfo',
                  label: '거래처 정보',
                  type: 'text',
                  placeholder: '거래처명을 입력해주세요'
                },
                {
                  name: 'terms',
                  label: '거래 조건',
                  type: 'textarea',
                  placeholder: '결제 기한, 할인 조건 등을 입력해주세요'
                }
              ]}
            />
          </div>
        )}

        {error && (
          <div className="p-4 bg-red-100 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        {result && (
          <div className="space-y-6">
            <ResultDisplay
              result={result}
              onFeedback={handleFeedback}
              feedbackSubmitted={feedbackSubmitted}
            />
            <div className="flex justify-center">
              <button
                onClick={handleReset}
                className="px-6 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition-colors"
              >
                새로운 분개 추천받기
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SalesPurchase; 